import {
  CompanyUsersRelation,
  CompanyUsersStatus
} from '@shared/types/companies.types'
import {
  Workspace,
  WorkspaceMember,
  WorkspaceUser
} from '@shared/types/workspaces.types'
import { useQuery } from '@tanstack/react-query'
import axiosClient from '../useAxios'

export const useWorkspaces = (companyId: string) => {
  return useQuery({
    queryKey: ['companies', companyId, 'workspaces'],
    queryFn: async (): Promise<(Workspace & { users: WorkspaceUser[] })[]> => {
      const response = await axiosClient.get(
        `/companies/${companyId}/workspaces`
      )
      return response.data.data.workspaces
    }
  })
}

export const useWorkspace = (companyId: string, workspaceId: string) => {
  return useQuery({
    queryKey: ['companies', companyId, 'workspaces', workspaceId],
    queryFn: async (): Promise<Workspace> => {
      const response = await axiosClient.get(
        `/companies/${companyId}/workspaces/${workspaceId}`
      )
      return response.data.data.workspace
    }
  })
}

export const useWorkspaceUsers = (
  companyId: string,
  workspaceId: string,
  queryParams?: {
    status?: CompanyUsersStatus
    relation?: CompanyUsersRelation
    role?: string
  }
) => {
  return useQuery({
    queryKey: [
      'companies',
      companyId,
      'workspaces',
      workspaceId,
      'users',
      queryParams
    ],
    queryFn: async (): Promise<WorkspaceMember[]> => {
      const searchParams = new URLSearchParams()

      if (queryParams?.status) {
        searchParams.append('status', queryParams.status)
      }
      if (queryParams?.relation) {
        searchParams.append('relation', queryParams.relation)
      }
      if (queryParams?.role) {
        searchParams.append('role', queryParams.role)
      }

      const queryString = searchParams.toString()
      const url = `/companies/${companyId}/workspaces/${workspaceId}/users${queryString ? `?${queryString}` : ''}`

      const response = await axiosClient.get(url)
      return response.data.data.workspaceUsers
    }
  })
}
